import React, { useState } from "react";
import { IconButton, Menu, ListItemButton, ListItemText, Tooltip, Badge, Divider } from "@mui/material";
import { NotificationsRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useReminderCounts from "hooks/useReminderCounts";

const DOT = {
  red: "bg-red-500",
  amber: "bg-amber-500",
  info: "bg-sky-500",
  green: "bg-emerald-500",
};

/**
 * Notifications bell. No dedicated backend yet — surfaces the same reminder
 * counts as the dashboard Reminders portlet (shared useReminderCounts hook).
 */
const NotificationsMenu = () => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState(null);
  const { items, total } = useReminderCounts();

  const active = items.filter((i) => i.count > 0);

  const go = (path) => {
    setAnchor(null);
    navigate(path);
  };

  return (
    <>
      <Tooltip title={t("notifications", "Notifications")}>
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)} sx={{ color: "var(--gray-color)" }}>
          <Badge badgeContent={total} color="error" max={99}>
            <NotificationsRounded />
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{ sx: { width: 320, maxHeight: 420 } }}
      >
        <div className="px-3 py-2 text-[12px] font-bold uppercase tracking-wider text-slate-500">
          {t("notifications", "Notifications")}
        </div>
        <Divider />
        {active.length === 0 ? (
          <div className="px-3 py-6 text-center text-[13px] text-slate-400">
            {t("noNotifications", "No notifications")}
          </div>
        ) : (
          active.map((i) => (
            <ListItemButton key={i.key} onClick={() => go(i.path)} className="!py-2">
              <span className={`w-2 h-2 rounded-full me-3 ${DOT[i.tone] || DOT.info}`} />
              <ListItemText
                primary={i.label}
                primaryTypographyProps={{ fontSize: 13 }}
              />
              <span className="text-[13px] font-bold text-slate-700 tabular-nums">{i.count}</span>
            </ListItemButton>
          ))
        )}
      </Menu>
    </>
  );
};

export default NotificationsMenu;
